(() => {
  const initMerchHeaderModes = () => {
    const header = document.querySelector('.header--merch-transparent, .header--merch-overlay');
    const hero = document.querySelector('[data-ci-merch-hero]');
    if (!header || !hero || header.dataset.merchHeaderReady) return;
    header.dataset.merchHeaderReady = 'true';

    const headerSection = header.closest('.shopify-section') || document.getElementById('shopify-section-header');
    let submenuOpen = false;

    const updateHeaderMode = () => {
      const headerHeight = headerSection ? headerSection.offsetHeight : header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      const heroHeight = hero.offsetHeight;
      const pastHero = heroHeight >= 80 && hero.getBoundingClientRect().bottom <= headerHeight + 8;
      document.body.classList.toggle('ci-merch-header-solid', pastHero || submenuOpen);
    };

    const syncSubmenu = (event) => {
      const related = event.relatedTarget;
      const enteredItem = event.target && event.target.closest && event.target.closest('.header__menu-item');
      if (event.type === 'mouseover' || event.type === 'focusin') {
        submenuOpen = !!enteredItem;
      } else if (!header.contains(related)) {
        submenuOpen = false;
      } else {
        submenuOpen = !!(related && related.closest && related.closest('.header__menu-item'));
      }
      updateHeaderMode();
    };

    header.addEventListener('mouseover', syncSubmenu);
    header.addEventListener('mouseout', syncSubmenu);
    header.addEventListener('focusin', syncSubmenu);
    header.addEventListener('focusout', syncSubmenu);

    const heroImage = hero.querySelector('.ci-merch-hero__image');
    if (heroImage && !heroImage.complete) {
      heroImage.addEventListener('load', updateHeaderMode, { once: true });
    }

    updateHeaderMode();
    window.addEventListener('scroll', updateHeaderMode, { passive: true });
    window.addEventListener('resize', updateHeaderMode);
  };

  const initMerchGallery = (media) => {
    if (media.dataset.merchGalleryReady) return;
    media.dataset.merchGalleryReady = 'true';

    const shell = media.closest('.product-card__media-shell');
    const track = media.querySelector('[data-merch-gallery-track]');
    const images = [...media.querySelectorAll('[data-gallery-index]')];
    if (images.length <= 1) return;

    let manualNav = false;

    const getCurrentIndex = () => {
      const active = images.findIndex((image) => image.classList.contains('is-active'));
      return active >= 0 ? active : 0;
    };

    const isHoverPreview = () => media.dataset.hoverPreview === 'true';

    const setupInfiniteTrack = () => {
      if (!track || track.dataset.infiniteReady === 'true') return;

      const firstClone = images[0].cloneNode(true);
      const lastClone = images[images.length - 1].cloneNode(true);

      firstClone.dataset.galleryClone = 'first';
      lastClone.dataset.galleryClone = 'last';
      firstClone.classList.remove('is-active', 'product-card__image--primary', 'product-card__image--secondary');
      lastClone.classList.remove('is-active', 'product-card__image--primary', 'product-card__image--secondary');
      firstClone.removeAttribute('data-gallery-index');
      lastClone.removeAttribute('data-gallery-index');

      track.insertBefore(lastClone, images[0]);
      track.appendChild(firstClone);
      track.dataset.infiniteReady = 'true';
    };

    const offsetForIndex = (logicalIndex) => logicalIndex + 1;

    const applyTrackOffset = (offsetIndex, { snap = false } = {}) => {
      if (!track) return;

      if (snap) {
        track.style.transition = 'none';
      }

      track.style.transform = `translate3d(-${offsetIndex * 100}%, 0, 0)`;

      if (snap) {
        void track.offsetHeight;
        track.style.transition = '';
      }
    };

    const setGalleryIndex = (index, { slideFrom = null } = {}) => {
      const total = images.length;
      const currentIndex = getCurrentIndex();
      const nextIndex = ((index % total) + total) % total;
      const useSlide = media.classList.contains('is-slide-mode');

      if (track && useSlide) {
        setupInfiniteTrack();

        const atHoverOrigin =
          track.style.transform === '' ||
          track.style.transform === 'translate3d(0, 0, 0)' ||
          track.style.transform === 'translate3d(0px, 0px, 0px)';

        if (
          atHoverOrigin &&
          slideFrom == null &&
          !(currentIndex === 0 && nextIndex === images.length - 1)
        ) {
          applyTrackOffset(offsetForIndex(currentIndex), { snap: true });
        }

        if (slideFrom != null && slideFrom !== nextIndex) {
          applyTrackOffset(offsetForIndex(slideFrom), { snap: true });
          requestAnimationFrame(() => {
            applyTrackOffset(offsetForIndex(nextIndex));
          });
        } else if (currentIndex === total - 1 && nextIndex === 0) {
          const onEnd = (event) => {
            if (event.target !== track || event.propertyName !== 'transform') return;
            track.removeEventListener('transitionend', onEnd);
            applyTrackOffset(offsetForIndex(0), { snap: true });
          };

          track.addEventListener('transitionend', onEnd);
          applyTrackOffset(total + 1);
        } else if (currentIndex === 0 && nextIndex === total - 1) {
          applyTrackOffset(0, { snap: true });
          requestAnimationFrame(() => {
            applyTrackOffset(offsetForIndex(total - 1));
          });
        } else {
          applyTrackOffset(offsetForIndex(nextIndex));
        }
      }

      images.forEach((image, imageIndex) => {
        image.classList.toggle('is-active', imageIndex === nextIndex);
      });
      media.dataset.galleryIndex = String(nextIndex);
      return nextIndex;
    };

    const updateGalleryMode = (index) => {
      const useSlide = manualNav || index !== 0;
      media.classList.toggle('is-slide-mode', useSlide);

      if (!useSlide && track) {
        track.style.transition = 'none';
        track.style.transform = 'translate3d(0, 0, 0)';
        void track.offsetHeight;
        track.style.transition = '';
      }
    };

    const showIndex = (index, { manual = false, slideFrom = null } = {}) => {
      manualNav = manual;
      media.dataset.galleryManual = manual ? 'true' : 'false';

      const hoverSkipNext =
        manual &&
        slideFrom == null &&
        getCurrentIndex() === 0 &&
        isHoverPreview() &&
        images.length > 2 &&
        ((index % images.length) + images.length) % images.length === 2;

      if (manual) {
        media.dataset.hoverPreview = 'false';
      }

      const projectedIndex = ((index % images.length) + images.length) % images.length;
      updateGalleryMode(projectedIndex);
      return setGalleryIndex(index, {
        slideFrom: hoverSkipNext ? 1 : slideFrom,
      });
    };

    const getArrowTargetIndex = (direction) => {
      const current = getCurrentIndex();
      const total = images.length;

      if (direction === 'next') {
        if (current === 0 && isHoverPreview() && total > 2) {
          return 2;
        }
        return current + 1;
      }

      if (current === 0 && isHoverPreview()) {
        return total - 1;
      }
      return current - 1;
    };

    const card = shell?.closest('.product-card--merch');

    shell?.addEventListener('mouseenter', () => {
      if (!manualNav && getCurrentIndex() === 0) {
        media.dataset.hoverPreview = 'true';
      }
    });

    shell?.addEventListener('mouseleave', () => {
      media.dataset.hoverPreview = 'false';
    });

    card?.addEventListener('mouseleave', () => {
      manualNav = false;
      media.dataset.galleryManual = 'false';
      media.dataset.hoverPreview = 'false';
      showIndex(0);
      if (card.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    });

    shell?.querySelector('[data-merch-gallery-prev]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      showIndex(getArrowTargetIndex('prev'), { manual: true });
    });

    shell?.querySelector('[data-merch-gallery-next]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      showIndex(getArrowTargetIndex('next'), { manual: true });
    });

    let swipeStartX = 0;
    let swipeStartY = 0;
    let swipeTracking = false;
    let didSwipe = false;

    media.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;
        swipeStartX = event.touches[0].clientX;
        swipeStartY = event.touches[0].clientY;
        swipeTracking = true;
        didSwipe = false;
      },
      { passive: true }
    );

    media.addEventListener(
      'touchend',
      (event) => {
        if (!swipeTracking) return;
        swipeTracking = false;

        const touch = event.changedTouches[0];
        if (!touch) return;

        const deltaX = touch.clientX - swipeStartX;
        const deltaY = touch.clientY - swipeStartY;

        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

        didSwipe = true;
        showIndex(getArrowTargetIndex(deltaX < 0 ? 'next' : 'prev'), { manual: true });
      },
      { passive: true }
    );

    media.addEventListener('touchcancel', () => {
      swipeTracking = false;
    });

    media.addEventListener('click', (event) => {
      if (!didSwipe) return;
      event.preventDefault();
      event.stopPropagation();
      didSwipe = false;
    });

    updateGalleryMode(getCurrentIndex());
  };

  const formatMerchMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme?.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }

    const amount = (Number(cents) || 0) / 100;
    return `Rp ${amount.toLocaleString('id-ID')}`;
  };

  const addMerchItemToCart = (variantId, quantity) => {
    const runAdd = () =>
      fetch(`${(window.routes && window.routes.cartAddUrl) || '/cart/add'}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: Number(quantity) || 1,
              properties: { _hidden_merch: '1' },
            },
          ],
        }),
      }).then((response) => {
        if (!response.ok) throw response;
        return response.json();
      });

    if (window.CiMerchCart && typeof window.CiMerchCart.assertCanAdd === 'function') {
      return window.CiMerchCart.assertCanAdd(true).then(runAdd);
    }
    return runAdd();
  };

  const initMerchQuickAddModal = () => {
    const modal = document.getElementById('CiMerchQuickAdd');
    if (!modal || modal.dataset.merchQuickAddReady) return;
    modal.dataset.merchQuickAddReady = 'true';
    document.body.appendChild(modal);

    const media = document.getElementById('CiMerchQuickAddMedia');
    const title = document.getElementById('CiMerchQuickAddTitle');
    const price = document.getElementById('CiMerchQuickAddPrice');
    const options = document.getElementById('CiMerchQuickAddOptions');
    const qtyInput = document.getElementById('CiMerchQuickAddQty');
    const atcButton = document.getElementById('CiMerchQuickAddAtc');
    const buyButton = document.getElementById('CiMerchQuickAddBuy');
    const errorBox = document.getElementById('CiMerchQuickAddError');

    let product = null;
    let selectedOptions = [];
    let productImages = [];

    const clearQuickAddError = () => {
      if (!errorBox) return;
      errorBox.hidden = true;
      errorBox.textContent = '';
    };

    const showQuickAddError = (message) => {
      if (!errorBox) {
        window.alert(message || (window.CiMerchCart && window.CiMerchCart.message) || 'Unable to add to cart');
        return;
      }
      errorBox.textContent =
        message || (window.CiMerchCart && window.CiMerchCart.message) || 'Unable to add to cart';
      errorBox.hidden = false;
    };

    const getProductImages = (nextProduct) => {
      const images = [];
      (nextProduct.images || []).forEach((src) => {
        const url = typeof src === 'string' ? src : src?.src;
        if (url && !images.includes(url)) images.push(url);
      });
      if (!images.length && nextProduct.featured_image) {
        images.push(nextProduct.featured_image);
      }
      return images;
    };

    const renderGallery = () => {
      if (!media) return;
      productImages = getProductImages(product);
      media.innerHTML = productImages
        .map(
          (src, index) =>
            `<img src="${src}" alt="${product.title.replace(/"/g, '&quot;')}" data-gallery-src="${src}" width="800" height="800"${index === 0 ? '' : ' loading="lazy"'}>`
        )
        .join('');
    };

    const resetGalleryScroll = () => {
      if (!media) return;
      media.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      media.scrollTop = 0;
    };

    const scrollGalleryTo = (src) => {
      if (!media || !src) return;
      const match = [...media.querySelectorAll('img')].find((img) => src.includes(img.getAttribute('data-gallery-src')) || img.src.includes(src.split('?')[0]));
      if (match) {
        match.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    };

    const closeModal = () => {
      resetGalleryScroll();
      clearQuickAddError();
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ci-merch-quick-add-open');
    };

    const getSelectedVariant = () => {
      if (!product) return null;
      return (
        product.variants.find((variant) =>
          selectedOptions.every((value, index) => (variant.options || [])[index] === value)
        ) || product.variants[0]
      );
    };

    const isOptionAvailable = (optionIndex, value) =>
      product.variants.some((variant) => {
        const matches = selectedOptions.every((selected, index) =>
          index === optionIndex ? variant.options[index] === value : variant.options[index] === selected
        );
        return matches && variant.available;
      });

    const updateModalState = ({ scrollGallery = false } = {}) => {
      if (!product) return;
      const variant = getSelectedVariant();
      if (!variant) return;

      if (scrollGallery && variant.featured_image?.src) {
        scrollGalleryTo(variant.featured_image.src);
      }

      const compare = Number(variant.compare_at_price || 0);
      const current = Number(variant.price || 0);
      price.innerHTML =
        compare > current
          ? `<span>${formatMerchMoney(current)}</span><span class="ci-merch-quick-add__price-compare">${formatMerchMoney(compare)}</span>`
          : `<span>${formatMerchMoney(current)}</span>`;

      options.querySelectorAll('[data-option-index]').forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const value = button.dataset.optionValue;
        button.classList.toggle('is-selected', selectedOptions[optionIndex] === value);
        button.classList.toggle('is-unavailable', !isOptionAvailable(optionIndex, value));
      });

      const available = Boolean(variant.available);
      atcButton.disabled = !available;
      buyButton.disabled = !available;
      atcButton.textContent = available ? 'Add to cart' : 'Sold out';
    };

    const renderOptions = () => {
      if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
        options.innerHTML = '';
        return;
      }

      options.innerHTML = (product.options || [])
        .map((option, optionIndex) => {
          const name = typeof option === 'string' ? option : option.name;
          if (!name || name === 'Title') return '';
          const values = option.values || [...new Set(product.variants.map((variant) => variant.options[optionIndex]))];
          return `
            <div class="ci-merch-quick-add__option">
              <span class="ci-merch-quick-add__option-label">${name}</span>
              <div class="ci-merch-quick-add__swatches">
                ${values
                  .map(
                    (value) =>
                      `<button type="button" class="ci-merch-quick-add__swatch" data-option-index="${optionIndex}" data-option-value="${String(value).replace(/"/g, '&quot;')}">${value}</button>`
                  )
                  .join('')}
              </div>
            </div>
          `;
        })
        .join('');
    };

    const openModal = (nextProduct) => {
      product = nextProduct;
      const firstAvailable = product.variants.find((variant) => variant.available) || product.variants[0];
      selectedOptions = [...(firstAvailable.options || [])];
      title.textContent = product.title;
      qtyInput.value = '1';
      clearQuickAddError();
      renderGallery();
      renderOptions();
      updateModalState({ scrollGallery: false });
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ci-merch-quick-add-open');
      requestAnimationFrame(() => {
        resetGalleryScroll();
        requestAnimationFrame(resetGalleryScroll);
      });
    };

    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-merch-quick-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    options.addEventListener('click', (event) => {
      const button = event.target.closest('[data-option-index]');
      if (!button) return;
      selectedOptions[Number(button.dataset.optionIndex)] = button.dataset.optionValue;
      updateModalState({ scrollGallery: true });
    });

    modal.querySelectorAll('[data-merch-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = Math.max(1, (Number(qtyInput.value) || 1) + Number(button.dataset.merchQty));
        qtyInput.value = String(next);
      });
    });

    const submitCart = (buyNow) => {
      const variant = getSelectedVariant();
      if (!variant || !variant.available) return;
      const quantity = Math.max(1, Number(qtyInput.value) || 1);

      clearQuickAddError();
      atcButton.disabled = true;
      buyButton.disabled = true;

      addMerchItemToCart(variant.id, quantity)
        .then(() => {
          if (buyNow) {
            window.location.href = '/checkout';
            return;
          }
          closeModal();
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { open: true },
            })
          );
        })
        .catch((error) => {
          if (error && error.code === 'MERCH_CART_MIX') {
            showQuickAddError(error.message);
            return;
          }
          if (error && typeof error.json === 'function') {
            error.json().then((data) => {
              showQuickAddError((data && data.description) || (error && error.message));
            });
            return;
          }
          showQuickAddError(error && error.message);
        })
        .finally(() => {
          updateModalState();
        });
    };

    atcButton.addEventListener('click', () => submitCart(false));
    buyButton.addEventListener('click', () => submitCart(true));

    modal._openWithProduct = openModal;
  };

  const openMerchQuickAdd = (button) => {
    if (!button || button.disabled) return;

    const handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    initMerchQuickAddModal();
    const modal = document.getElementById('CiMerchQuickAdd');

    fetch(`/products/${handle}.js`)
      .then((response) => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then((product) => {
        if (modal && typeof modal._openWithProduct === 'function') {
          modal._openWithProduct(product);
        }
      })
      .catch(() => {
        window.location.href = button.getAttribute('data-product-url') || `/products/${handle}`;
      });
  };

  const initMerchQuickAddDelegation = () => {
    if (document.body.dataset.merchQuickAddDelegate === 'true') return;
    document.body.dataset.merchQuickAddDelegate = 'true';

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-merch-quick-add]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      openMerchQuickAdd(button);
    });
  };

  const initMerchQuickAdd = (button) => {
    if (!button || button.dataset.merchQuickAddReady) return;
    button.dataset.merchQuickAddReady = 'true';
  };

  /* Merch media belum dipakai
  const initMerchVideoCover = (video) => {
    if (video.dataset.ciMerchVideoCoverReady) return;
    video.dataset.ciMerchVideoCoverReady = 'true';

    const container = video.closest('[data-ci-merch-video]');
    const fallbackSecond = parseFloat(container?.getAttribute('data-video-cover-second') || '2');
    const coverSecond = Math.max(0, parseFloat(video.dataset.coverSecond || fallbackSecond) || 0);

    const applyCoverFrame = () => {
      try {
        const duration = Number.isFinite(video.duration) ? video.duration : coverSecond;
        const target = duration > 0 ? Math.min(coverSecond, Math.max(0, duration - 0.05)) : coverSecond;
        video.currentTime = target;
      } catch (error) {
        // ignore seek errors before metadata is ready
      }
    };

    video.pause();
    video.muted = true;

    if (video.readyState >= 1) {
      applyCoverFrame();
    } else {
      video.addEventListener('loadedmetadata', applyCoverFrame, { once: true });
    }

    video.addEventListener('seeked', () => {
      video.pause();
    });
  };

  const initMerchVideo = (container) => {
    if (container.dataset.ciMerchVideoReady) return;
    container.dataset.ciMerchVideoReady = 'true';

    container.querySelectorAll('[data-ci-merch-video-cover]').forEach(initMerchVideoCover);

    const playBtn = container.querySelector('[data-ci-merch-video-play]');
    if (!playBtn) return;

    playBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const videoType = container.getAttribute('data-video-type');
      const videoSrc = container.getAttribute('data-video-src');
      const videoAlt = container.getAttribute('data-video-alt') || 'Video player';
      if (!videoSrc) return;

      let playerElement;

      if (videoType === 'html5') {
        playerElement = document.createElement('video');
        playerElement.src = videoSrc;
        playerElement.className = 'ci-merch-media__player';
        playerElement.controls = true;
        playerElement.autoplay = true;
        playerElement.playsInline = true;
        playerElement.setAttribute('aria-label', videoAlt);
      } else if (videoType === 'youtube' || videoType === 'vimeo') {
        playerElement = document.createElement('iframe');
        playerElement.src = videoSrc;
        playerElement.className = 'ci-merch-media__player';
        playerElement.setAttribute('allow', 'autoplay; encrypted-media');
        playerElement.setAttribute('allowfullscreen', '');
        playerElement.setAttribute('title', videoAlt);
      }

      if (!playerElement) return;

      container.querySelector('.ci-merch-media__picture')?.remove();
      container.querySelector('[data-ci-merch-video-cover]')?.remove();
      container.querySelector('.ci-merch-media__cover')?.remove();
      playBtn.remove();
      container.appendChild(playerElement);
    });
  };
  */

  const initMerchProductCards = (scope = document) => {
    scope.querySelectorAll('[data-merch-gallery]').forEach(initMerchGallery);
    scope.querySelectorAll('[data-merch-quick-add]').forEach(initMerchQuickAdd);
  };

  /* Merch media belum dipakai
  const initMerchMedia = (scope = document) => {
    scope.querySelectorAll('[data-ci-merch-video]').forEach(initMerchVideo);
  };
  */

  const initMerchCollection = (scope = document) => {
    initMerchHeaderModes();
    initMerchQuickAddDelegation();

    scope.querySelectorAll('[data-ci-merch-collection]').forEach((section) => {
      if (section.dataset.ciMerchReady) return;
      section.dataset.ciMerchReady = 'true';
      initMerchProductCards(section);
    });

    if (!scope.querySelector('[data-ci-merch-collection]')) {
      initMerchProductCards(scope);
    }

    // initMerchMedia(scope);
  };

  window.initMerchProductCards = initMerchProductCards;

  document.addEventListener('DOMContentLoaded', () => initMerchCollection());
  document.addEventListener('shopify:section:load', (event) => initMerchCollection(event.target || document));
})();
